/**
 * author： blake.li
 * createDate: 2020-01-15
 * description: 获取位置信息, 目前对外暴露，获取所在城市、获取经纬度信息、获取cookie中缓存的经纬度信息等方法
 */

const CACHE_LOCATION = 'cacheLocation';
const LOCATION_DENIED_TIME = 'locationDeniedTime';
const SPECIAL_CITY_NAME = ['胡志明市', '芒市'];
import Qfetch from "@qnpm/react-native-ext-fetch";
import {getItem, setItem} from '../StorageUtils';

export function getLocationCity() {
    // return new Promise((resolve, reject) => {
    //     getCurrentLocation().then((location) => {
    //         getCityByLocation(location).then(city => {
    //             resolve(city);
    //         }).catch(() => {
    //             resolve({})
    //         })
    //     }).catch(() => {
    //         resolve({})
    //     })
    // })
    return getCityByIp();
}

// 实时获取当前定位信息（经纬度等）
function getCurrentLocation() {
    return new Promise((resolve, reject) => {
        if (hysdk.getLocation) {
            hysdk.getLocation({
                type: 'wgs84',
                timeout: 5000,
                success: function (location) {
                    resolve(location);
                },
                fail: function () {
                    reject();
                }
            });
        } else {
            if (getItem(LOCATION_DENIED_TIME) && parseInt(getItem(LOCATION_DENIED_TIME)) >= new Date().getTime()) {
                reject();
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(location => resolve(location), (error) => {
                    markDenied(error);
                    reject();
                }, {timeout: 3000});
            } else {
                console.log('Geolocation is not supported by this browser.');
            }
        }
    });
}

// 根据位置信息（经纬度等），获取城市信息
function getCityByLocation(location) {
    let longitude = location.coords.longitude;
    let latitude = location.coords.latitude;
    let expires = new Date();
    expires.setTime(expires.getTime() + 2 * 24 * 60 * 60 * 1000);
    return new Promise((resolve, reject) => {
        Qfetch({
            url: '/gw/f/a/locationCityInfo',
            method: 'get',
            requestType: 'json',
            body: {
                latitude,
                longitude,
                type: 1,
                from: 'low_price_rn'
            },
            timeout: 2000
        }).then((res) => {
            let bStatus = res.bstatus, data = res.data;
            if (bStatus && bStatus.code === 0 && data && data.cityName) {
                resolve(data);
            } else {
                reject();
            }

        }).catch((e) => {
            reject();
        });
    });
}
// 标记用户拒绝获取位置信息
function markDenied(error) {
    //error.PERMISSION_DENIED 为 1  用户点击禁止获取定位的时候
    if (error.code && error.code === 1 && localStorage) {
        let expires = new Date();
        expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
        localStorage.setItem(LOCATION_DENIED_TIME, expires.getTime().toString());
    }
}

// 特殊城市处理
function justifyCityName(city) {
    if (/市$/.test(city) && SPECIAL_CITY_NAME.indexOf(city) === -1) {
        city = city.slice(0, -1);
    }
    return city;
}

function getCityByIp() {
    return new Promise((resolve) => {
        Qfetch({
            url: '/gw/f/flight/api/ipToCity',
            method: 'get',
            requestType: 'json',
            timeout: 5000,
            from: 'low_price_rn'
        }).then(res => {
            if (res && res.data && res.data.city) {
                let cityName = res.data.city;
                if (cityName && cityName != '') {
                    resolve({cityName: justifyCityName(cityName)});
                } else {
                    resolve({});
                }
            } else {
                resolve({});
            }
        }).catch(() => {
            resolve({});
        });
    });
}
